import React from 'react'

import './PageLayoutAlert.scss'

const PageLayoutAlert = props => {
  return (
    <div className="PageLayoutAlert">
      Por las restricciones dispuestas por la pandemia de COVID19, los horarios y modalidades de atención pueden haberse modificado. Antes de ir, consultá con el local.
    </div>
  )
}

export default PageLayoutAlert
